const TextInput = ({ label, type = "text", ...props }) => {
    return (
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          {label}
        </label>
        <input
          type={type}
          className="w-full border-b border-gray-300 focus:border-green-900 outline-none py-2 text-sm"
          {...props}
        />
      </div>
    );
  };
  
  export default TextInput;
  